import React from "react";
import {
  ModalContentContainer,
  ModalHeader,
  ModalTitle,
  ModalContent,
  ContentModal,
  MessageContainer,
  Message,
  ActionButton,
  ButtonOk,
} from "./ModalICEAdminMessage.styled";
import PortalModal from "../../Portals/PortalModal";
import { Tooltip, IconButton } from "@material-ui/core";
import { ReactComponent as CloseIcon } from "../../themes/Icons/close_icon.svg";
import { AccountCircle } from "@material-ui/icons";

const ModalICEAdminMessage = ({ messages, setModalVisibility }) => {
  return (
    <PortalModal>
      <ContentModal>
        <ModalContentContainer>
          <ModalHeader>
            <ModalTitle>Your request is being attendent</ModalTitle>
            <Tooltip title="close">
              <IconButton
                className="close-button"
                onClick={() => setModalVisibility(false)}
              >
                <CloseIcon />
              </IconButton>
            </Tooltip>
          </ModalHeader>
          <ModalContent>
            {messages.map((text, index) => {
              return (
                <MessageContainer showIcon={index === 0 ? true : false}>
                  <AccountCircle />
                  <Message>
                    <label>{text}</label>
                  </Message>
                </MessageContainer>
              );
            })}
          </ModalContent>
          <ActionButton>
            <ButtonOk onClick={() => setModalVisibility(false)}>OK</ButtonOk>
          </ActionButton>
        </ModalContentContainer>
      </ContentModal>
    </PortalModal>
  );
};

export default ModalICEAdminMessage;
